import Portfolio from "@/modules/team/portfolio";
import CustomDrawer from "@/components/drawer";
import Header from "@/components/header";
import { useAuth } from "@/context/auth";
import {
  MerchantUserDto,
  MerchantUserStatus,
  MerchantUserType,
} from "@/models/club";
import ProfileDetail from "@/modules/team/profileDetail";
import ProfileDetailSetting from "@/modules/team/profileDetail/Setting";
import { useGetMerchantForMerchantUser } from "@/services/merchant/utilities";
import useGetMerchantUserById from "@/services/merchantUser/hooks/useGetMerchantUserById";
import { useGetImage } from "@/utilities/helper/getImage";
import {
  Alert,
  Avatar,
  Button,
  Container,
  Group,
  Menu,
  Skeleton,
  Stack,
  Tabs,
  Text,
  Title,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconAlertCircle, IconChevronDown } from "@tabler/icons-react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
function TeamMemberDetail() {
  const { id } = useParams();
  const [params, setParams] = useSearchParams();
  const [opened, { open, close }] = useDisclosure(false);
  const navigate = useNavigate();
  const { data, isLoading } = useGetMerchantUserById(Number(id));
  const user = data as MerchantUserDto;

  const { getUserByToken } = useAuth();

  const { data: merchantUser } = useGetMerchantForMerchantUser(
    getUserByToken()?.phoneNumber ?? ""
  );

  const isAdmin = merchantUser?.merchantUserType !== MerchantUserType.Value2;

  const { imageUrl } = useGetImage({ image: user?.image });
  return (
    <>
      <Header
        title=""
        showBack
        customComponentHide
        customComponent={
          <>
            <Group>
              <Avatar
                variant="outline"
                color="blue"
                size="md"
                src={imageUrl}
                p="3"
                styles={{
                  image: {
                    borderRadius: "100px",
                  },
                  root: {
                    border: `1px solid ${user?.calendarColor}`,
                  },
                }}
              >
                {user?.firstName?.charAt(0) || ""}
              </Avatar>
              <Text>
                {user?.firstName} {user?.lastName}
              </Text>
            </Group>
          </>
        }
      />
      <Container w="100%" size="md" bg="white">
        <Group justify="space-between">
          <Stack gap="xs">
            <Title order={4} pb="0">
              {isLoading ? (
                <Skeleton w="150px" height={20} />
              ) : (
                <>
                  {user?.firstName} {user?.lastName}
                </>
              )}
            </Title>
            {user?.status === MerchantUserStatus.Value0 && (
              <Alert color="yellow" px="0" py="2">
                <Group gap={5}>
                  <IconAlertCircle stroke={1} size={15} />
                  <Text size="10px" fw="lighter">
                    در انتظار قبول دعوت نامه
                  </Text>
                </Group>
              </Alert>
            )}
            {isAdmin && (
              <Button
                radius="xl"
                variant="default"
                leftSection={<IconChevronDown stroke={1} size={16} />}
                size="xs"
                w="100px"
                onClick={open}
              >
                <Text size="xs">عملیات</Text>
              </Button>
            )}
          </Stack>

          <Avatar
            variant="outline"
            color="blue"
            size="xl"
            src={imageUrl}
            p="3"
            styles={{
              image: {
                borderRadius: "100px",
              },
              root: {
                border: `3px solid ${user?.calendarColor}`,
              },
            }}
          >
            {user?.firstName?.charAt(0) || ""}
          </Avatar>
        </Group>

        <Stack justify="start" mt="lg">
          <Tabs value={params.get("tab") || "profile"} onChange={value => setParams({ tab: value || "profile" })} keepMounted color="dark">
            <Tabs.List>
              <Tabs.Tab value="portfolio">بیوگرافی و نمونه‌کار</Tabs.Tab>
              <Tabs.Tab value="profile">
                <Text fw="500">اطلاعات شخصی</Text>{" "}
              </Tabs.Tab>
              {isAdmin && (
                <Tabs.Tab value="workspace">
                  <Text fw="500">تنظیمات</Text>
                </Tabs.Tab>
              )}
            </Tabs.List>

            <Tabs.Panel value="portfolio" pt="xl" pb="lg">
              <Portfolio key={id} memberId={Number(id)} />
            </Tabs.Panel>
            <Tabs.Panel value="profile" pt="xl" pb="lg">
              <ProfileDetail user={user} isLoading={isLoading} />
            </Tabs.Panel>

            <Tabs.Panel value="workspace" pt="xl">
              <ProfileDetailSetting
                isLoading={isLoading}
                merchantServicesLength={user?.merchantServices?.length || 0}
                merchantUserType={
                  user?.merchantUserType || MerchantUserType.Value0
                }
                userId={user?.id || 0}
              />
            </Tabs.Panel>
          </Tabs>
        </Stack>
      </Container>
      <CustomDrawer
        opened={opened}
        onClose={close}
        close={close}
        custom="edit-profile-setting"
        position="bottom"
        size="200"
      >
        <Menu>
          <Menu.Item
            onClick={() => navigate(`/dashboard/teams/teamMembers/edit/${id}`)}
          >
            <Text fw="500"> ویرایش</Text>
          </Menu.Item>
          <Menu.Item>
            <Text fw="500"> مشاهده تقویم کاری</Text>
          </Menu.Item>
          <Menu.Item>
            <Text fw="500" c="red">
              {" "}
              آرشیو
            </Text>
          </Menu.Item>
        </Menu>
      </CustomDrawer>
    </>
  );
}

export default TeamMemberDetail;
